import { render, staticRenderFns } from "./trainingTrainers.vue?vue&type=template&id=02b224e6"
import script from "./trainingTrainers.vue?vue&type=script&lang=js"
export * from "./trainingTrainers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports